import React, {useState} from 'react';
import {Trans, useTranslation} from "react-i18next";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {FormHelperText} from "@mui/material";

function TextParam({id, values, onChange, value, forCart, inCart, props}) {
    const {t} = useTranslation();

    const [error, setError] = useState('')

    const handleChange = (event) => {
        if (props?.maxLength) {
            if (event.target.value.length <= (props.maxLength)) {
                onChange(id, event.target.value);
                setError('');
            } else {
                setError(t('errors.text.maxLength', {maxLength: props.maxLength}));
            }
        } else {
            onChange(id, event.target.value);
        }
    }

    return (forCart ?
            <Typography sx={{overflow: "hidden", textOverflow: 'ellipsis', textWrap: 'nowrap',color: 'text.secondary'}} variant={'body2'}>
                <Trans i18nKey={`params.${id}`}/>: {value}
            </Typography> :
            <FormControl fullWidth>
                <TextField
                    autoFocus={inCart}
                    id={id}
                    value={value}
                    label={t(`params.${id}`)}
                    placeholder={t(`params.${id}`)}
                    sx={{height: 40}}
                    size="small"
                    onChange={handleChange}
                />
                <FormHelperText error>{error}</FormHelperText>
            </FormControl>
    );
}

export default TextParam;
